import { AppUser } from '../../../views/App/App';
import axios from 'Src/helpers/api/axiosInstance';

export function acceptInvite(user: AppUser, inviteId: string, data: { eventIds?: string[] } = {}) {
  const { roleSessionKey: key, activeSchoolId } = user;
  const config: any = {
    headers: { usid: key },
    skipAuthRedirect: true
  };

  return axios
    .post(`${window.apiBase}/i/schools/${activeSchoolId}/invites/${inviteId}/accept`, data, config)
    .then(response => {
      return response.data;
    });
}

export function acceptAutoEnrollmentInvite(user: AppUser, inviteId: string, data: { eventIds?: string[] } = {}) {
  const { roleSessionKey: key, activeSchoolId } = user;
  const config: any = {
    headers: { usid: key },
    skipAuthRedirect: true
  };

  return axios
    .post(`${window.apiBase}/i/schools/${activeSchoolId}/invites/${inviteId}/autoenrollment`, data, config)
    .then(response => {
      return response.data;
    });
}

export function getInvites(user: AppUser, filter?) {
  const { roleSessionKey: key, activeSchoolId } = user;
  const config = {
    headers: { usid: key },
    params: {
      filter
    }
  };

  return axios.get(`${window.apiBase}/i/schools/${activeSchoolId}/invites`, config).then(response => {
    return response.data;
  });
}

export function getInvite(user: AppUser, inviteId: string) {
  const { roleSessionKey: key, activeSchoolId } = user;
  const config = {
    headers: { usid: key }
  };

  return axios.get(`${window.apiBase}/i/schools/${activeSchoolId}/invites/${inviteId}`, config).then(response => {
    return response.data;
  });
}

export function withdrawTournamentBooking(user: AppUser, tournamentId: string) {
  const { roleSessionKey: key, activeSchoolId } = user;
  const config = {
    headers: { usid: key }
  };

  return axios
    .post(`${window.apiBase}/i/schools/${activeSchoolId}/tournaments/${tournamentId}/withdrawBooking`, {}, config)
    .then(response => {
      return response.data;
    });
}
